﻿/**
 * Checks if a given message is a valid message by checking
 * the presence of a specific boolean flag.
 *
 * @param message Message to be checked.
 * @return true if message is valid (client or iframe).
 */
export const isValidMessage = /* #__PURE__ */ function (message) {
    return (!!message &&
        typeof message === "object" &&
        message.isCrossOriginHtmlEmbedMessage === true);
};
